
import { PeopleGroup } from '../types/region-types';
import { JOSHUA_PROJECT_API_KEY, getJoshuaProjectApiUrl } from '../../utils/api-keys';

export const fetchJoshuaProjectData = async (): Promise<PeopleGroup[]> => {
  try {
    const response = await fetch(getJoshuaProjectApiUrl('v1/people-groups/global'));
    
    if (!response.ok) {
      console.warn('Falling back to sample data due to API error');
      return generateSamplePledgeData();
    }
    
    const data = await response.json();
    return data.peoples || generateSamplePledgeData();
  } catch (error) {
    console.warn('Error fetching Joshua Project data, using sample data:', error);
    return generateSamplePledgeData();
  }
};

// Add the missing compareJoshuaProjectData function
export const compareJoshuaProjectData = (a: PeopleGroup, b: PeopleGroup): number => {
  // Compare by population size (largest first)
  return b.population - a.population;
};

// Generate sample pledge data for global regions
function generateSamplePledgeData(): PeopleGroup[] {
  const sampleRegions = [
    { name: "North America", coords: [-100.5469, 46.0730] as [number, number], amount: 2500000 },
    { name: "South America", coords: [-58.9375, -13.2399] as [number, number], amount: 1800000 },
    { name: "Europe", coords: [15.2551, 54.5260] as [number, number], amount: 3200000 },
    { name: "Africa", coords: [19.0019, 9.5375] as [number, number], amount: 900000 },
    { name: "Asia", coords: [103.8477, 34.0479] as [number, number], amount: 4100000 },
    { name: "Oceania", coords: [134.3704, -25.2744] as [number, number], amount: 1200000 },
    { name: "Middle East", coords: [45.0792, 23.8859] as [number, number], amount: 1500000 },
    { name: "Southeast Asia", coords: [114.4414, 4.2105] as [number, number], amount: 2000000 },
    { name: "Central America", coords: [-88.6328, 15.4763] as [number, number], amount: 800000 },
    { name: "Caribbean", coords: [-71.5435, 18.9712] as [number, number], amount: 600000 },
    // Additional global regions for broader coverage
    { name: "Eastern Europe", coords: [30.5234, 50.4501] as [number, number], amount: 1700000 },
    { name: "West Africa", coords: [-1.0232, 7.9465] as [number, number], amount: 850000 },
    { name: "East Africa", coords: [36.8219, 1.2921] as [number, number], amount: 920000 },
    { name: "South Asia", coords: [77.2090, 28.6139] as [number, number], amount: 2300000 },
    { name: "East Asia", coords: [116.4074, 39.9042] as [number, number], amount: 2800000 },
    { name: "Nordic Countries", coords: [18.0686, 59.3293] as [number, number], amount: 1100000 },
    { name: "Mediterranean", coords: [12.4964, 41.9028] as [number, number], amount: 1600000 },
    { name: "Pacific Islands", coords: [174.7762, -41.2865] as [number, number], amount: 400000 }
  ];

  return sampleRegions.map((region, idx) => ({
    id: `JP${idx + 1}`,
    name: region.name,
    population: Math.floor(Math.random() * 5000000) + 1000000,
    evangelical_percentage: Math.random() * 10,
    primary_religion: "Various",
    primary_language: "Various",
    region_id: region.name.replace(/\s+/g, '_').toUpperCase(),
    coordinates: region.coords,
    pledges: region.amount,
    global_region: true
  }));
}
